import type { StatusChipConfig } from '@verantos-dev/feature-analytical-variables';
import { colors } from '@verantos-dev/shared-ui-components/tokens';
import { CriteriaSelection } from '@verantos-dev/types-cohorts';

/** Single source of truth for criteria role chip colors used across cards, modals, and dropdowns. */
export const CRITERIA_CHIP_STYLES = {
  INDEX_DATE: { backgroundColor: colors['primary-700'], color: colors.white },
  INCLUSION: { backgroundColor: colors['success-700'], color: colors.white },
  EXCLUSION: { backgroundColor: colors['error-700'], color: colors.white },
  NOT_APPLIED: {
    // TODO: no VDS token for this value — needs designer input (Barry Richardson)
    backgroundColor: '#E0E0E0',
    // TODO: no VDS token for this value — needs designer input (Barry Richardson)
    color: '#424242',
  },
} as const;

/** Status chips shown when an AV is used as the index date (always inclusive). */
export const INDEX_DATE_CHIPS: StatusChipConfig[] = [
  { label: 'Index date', ...CRITERIA_CHIP_STYLES.INDEX_DATE },
  { label: 'Inclusion', ...CRITERIA_CHIP_STYLES.INCLUSION },
];

/** Error chip style for AV unresolved concept groups. */
export const AV_ERROR_CHIP_STYLE = {
  // TODO: no VDS token for this value — needs designer input (Barry Richardson)
  backgroundColor: '#FEE2E2',
  // TODO: no VDS token for this value — needs designer input (Barry Richardson)
  color: '#B91C1C',
} as const;

/** Error chip shown when an AV has unresolved concept groups. */
export const AV_ERROR_CHIP: StatusChipConfig = {
  label: 'Error',
  ...AV_ERROR_CHIP_STYLE,
};

/** Error chip with count of unresolved concept groups. */
export const buildAVErrorChip = (errorCount: number): StatusChipConfig => ({
  label: errorCount === 1 ? '1 Error' : `${errorCount} Errors`,
  ...AV_ERROR_CHIP_STYLE,
});

/** Derive status chips from a CriteriaSelection value. */
export function buildCriteriaStatusChips(
  criteriaSelection: string | undefined
): StatusChipConfig[] | undefined {
  if (criteriaSelection === CriteriaSelection.INCLUSION) {
    return [{ label: 'Inclusion', ...CRITERIA_CHIP_STYLES.INCLUSION }];
  }
  if (criteriaSelection === CriteriaSelection.EXCLUSION) {
    return [{ label: 'Exclusion', ...CRITERIA_CHIP_STYLES.EXCLUSION }];
  }
  if (criteriaSelection === CriteriaSelection.NOT_APPLIED) {
    return [{ label: 'Not applied', ...CRITERIA_CHIP_STYLES.NOT_APPLIED }];
  }
  return undefined;
}
